// src/pages/ComponentCardsPage.tsx
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMasterBriefStore } from "../../store/masterBriefStore";
import "./AuthoringStyleSheets/ComponentCardsPage.css"; // 👈 add a dedicated CSS file

export default function ComponentCardsPage() {
  const navigate = useNavigate();
  const { briefs, loading, error, hasLoadedOnce, load } = useMasterBriefStore();

  useEffect(() => {
    if (!hasLoadedOnce) void load();
  }, [hasLoadedOnce, load]);

  const handleOpen = (masterAssemblyId?: number | null) => {
    if (!masterAssemblyId) return;
    navigate(`/authoring/view/${masterAssemblyId}`);
  };

  return (
    <div className="components-page container py-4" style={{marginTop:"20px"}}>
      {/* Header Section */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="page-title text-center">Components</h2>

        <button
          type="button"
          className="btn btn-outline-primary btn-sm"
          onClick={() => load()}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Refreshing…
            </>
          ) : (
            "Refresh"
          )}
        </button>
      </div>

      {/* Error State */}
      {error && (
        <div className="alert alert-danger mb-4" role="alert">
          {error}
        </div>
      )}

      {/* Loading Spinner (initial only) */}
      {loading && briefs.length === 0 && (
        <div className="loading-wrapper my-5">
          <div className="spinner-border" role="status" aria-label="Loading"></div>
          <span className="ms-2">Loading components…</span>
        </div>
      )}

      {/* Cards Grid */}
      <div className="row g-4">
        {(briefs.length ? briefs : loading ? Array.from({ length: 8 }) : []).map((b: any, idx: number) => {
          const key = b?.masterAssemblyId ?? idx;
          const title: string = b?.componentPartNumber ?? "—";
          const desc: string = b?.componentDescription ?? "";
          const img: string = b?.mainSvg?.folderPath || "";

          const baseUrl = process.env.REACT_APP_API_BASE_URL || "";
          const imgFullPath = img ? `${baseUrl}/media/${img}` : "";

          return (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={key}>
              <div
                className="component-card card h-100"
                role="button"
                tabIndex={0}
                onClick={() => handleOpen(b?.masterAssemblyId)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") handleOpen(b?.masterAssemblyId);
                }}
              >
                {img ? (
                  <img src={imgFullPath} className="card-img-top" alt={title} />
                ) : (
                  <div className="card-img-placeholder">No preview</div>
                )}

                <div className="card-body d-flex flex-column">
                  <h6 className="card-title mb-1 text-truncate">{title}</h6>
                  <p className="card-text text-muted mb-3 text-truncate" title={desc}>
                    {desc}
                  </p>

                  <div className="mt-auto d-flex justify-content-end">
                    <button
  type="button"
  className="btn btn-sm view-btn"
  onClick={(e) => {
    e.stopPropagation();
    handleOpen(b?.masterAssemblyId);
  }}
>
  View
</button>

                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Empty State */}
      {!loading && briefs.length === 0 && !error && hasLoadedOnce && (
        <div className="alert alert-info mt-4" role="alert">
          No components to display.
        </div>
      )}
    </div>
  );
}
